import { render, staticRenderFns } from "./triage.vue?vue&type=template&id=762d9c2e"
import script from "./triage.vue?vue&type=script&lang=js"
export * from "./triage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports